import { router } from "@inertiajs/react";
import { useRef, useState } from "react";

import backgroundRed from "@/assets/background_red.svg";
import AuthCard from "@/components/AuthCard";
import Button from "@/components/Button";
import CourseSummaryCard from "@/components/CourseSummaryCard";
import {
  cancelForStudentEnrollment,
  studentConfirmationEnrollment,
} from "@/routes";
import type { Course, Enrollment } from "@/types";

type Props = {
  data: Enrollment;
  course: Course;
  token?: string;
  restriction_reason?: string;
};

export default function ConfirmForStudent({
  data: enrollment,
  course,
  token,
  restriction_reason: restrictionReason,
}: Props) {
  const [processing, setProcessing] = useState(false);
  // `disabled` only takes effect after a re-render, so a rapid double-click
  // can still fire two requests; this ref blocks the second one synchronously.
  const submittingRef = useRef(false);

  function confirm() {
    if (submittingRef.current) return;
    submittingRef.current = true;

    const options = token ? { query: { token } } : undefined;
    router.post(
      studentConfirmationEnrollment(enrollment.id, options).url,
      undefined,
      {
        onStart: () => setProcessing(true),
        onFinish: () => {
          submittingRef.current = false;
          setProcessing(false);
        },
      },
    );
  }

  function goToCancel() {
    const options = token ? { query: { token } } : undefined;
    router.get(cancelForStudentEnrollment(enrollment.id, options).url);
  }

  return (
    <AuthCard title="Confirma tu inscripción" background={backgroundRed}>
      <div className="flex flex-col gap-6">
        <CourseSummaryCard course={course} />

        <div className="flex flex-col gap-3 self-center">
          {restrictionReason ? (
            <p className="max-w-sm rounded-2xl border-2 border-deep-red/40 bg-deep-red/5 px-4 py-3 text-center font-sans text-sm text-deep-red">
              {restrictionReason}
            </p>
          ) : (
            <Button type="button" disabled={processing} onClick={confirm}>
              Confirma tu inscripción
            </Button>
          )}

          <Button
            type="button"
            variant="secondary"
            disabled={processing}
            onClick={goToCancel}
          >
            Anula tu inscripción
          </Button>
        </div>
      </div>
    </AuthCard>
  );
}
